import {AbstractPart} from "./AbstractPart";
import {IFormPartParameters} from "./index";
import buttonHtml from './button.html?raw';

export let template = buttonHtml;

export class viewModel extends AbstractPart {
    private text: string;

    constructor(params: IFormPartParameters) {
        super(params);
        this.text = this.parameters[3] ?? '';
    }

    private isEnabled(): boolean {
        return this.params.isValid?.() ?? true;
    }

}
